
export const IntranetTrainingRequest = {
    path: '/intranet_training_requests',
    name: 'intranet_training_requests',
    component: () => import('@/views/Intranet/IntranetTrainingRequestPage.vue'),
    children: [
        {
            path: '/intranet_training_requests/add',
            name: 'intranet_training_requests.add',
            component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestForm.vue'),
            props: {addAction: true, intranet: true}
        },
        {
            path: '/intranet_training_requests/edit/:id',
            name: 'intranet_training_requests.edit',
            component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestForm.vue'),
            props: {updateAction: true, intranet: true}
        },
        {
            path: '/intranet_training_requests/delete/:id',
            name: 'intranet_training_requests.delete',
            component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestForm.vue'),
            props: {deleteAction: true, intranet: true}
        },
        {
            path: '/intranet_training_requests/view/:id',
            name: 'intranet_training_requests.view',
            component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestForm.vue'),
            props: {viewAction: true, intranet: true}
        },
        {
            path: '/intranet_training_requests/timelines/:id/:module',
            name: 'intranet_training_requests.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/intranet_training_requests/documents/:id',
            name: 'intranet_training_requests.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "TRAINING_REQUEST"}
        },
    ],
}